<script lang="ts" module>
	export const symbolId = "ishavskraft-icon-caret-down";
	export const symbol = `
		<symbol id="${symbolId}" viewBox="0 0 9 5" xmlns="http://www.w3.org/2000/svg">
			<path d="M3.775 4.475L0.15 0.85C0.1 0.8 0.0626668 0.746 0.0380001 0.688C0.0133334 0.63 0.000666667 0.567333 0 0.5C0 0.366667 0.046 0.25 0.138 0.15C0.23 0.0499996 0.350667 0 0.5 0H8.1C8.25 0 8.371 0.0499996 8.463 0.15C8.555 0.25 8.60067 0.366667 8.6 0.5C8.6 0.533333 8.55 0.65 8.45 0.85L4.825 4.475C4.74167 4.55833 4.65833 4.61667 4.575 4.65C4.49167 4.68333 4.4 4.7 4.3 4.7C4.2 4.7 4.10833 4.68333 4.025 4.65C3.94167 4.61667 3.85833 4.55833 3.775 4.475Z" fill="currentcolor"/>
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		class: classes = null,
		ariaHidden = true,
	}: {
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

<svg
	aria-hidden={ariaHidden}
	width="9"
	height="5"
	viewBox="0 0 9 5"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class={classes}
>
	<use href="#{symbolId}" />
</svg>
